module.exports = __webpack_public_path__ + "img/chat_icon_small_teriatry.8bf8cee9.svg";